module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("9FZOJ"))).then(() => parcelRequire('d0iPb'));